
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateMeetingAgendaItemDtoFormGroup() {
return new FormGroup({
    meetingId: new FormControl<number | undefined>(undefined, [Validators.required]),
    sortableRank: new FormControl<number | undefined>(undefined),
    title: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(255)]),
    description: new FormControl<string | undefined>(''),
    protocolNotes: new FormControl<string | undefined>(''),
    duration: new FormControl<number | undefined>(undefined),
})
;
}
      